export function HoneypotIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 64 64" role="img" aria-hidden focusable="false">
      <defs>
        <linearGradient id="hp-pot" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#e89b3c" />
          <stop offset="1" stopColor="#a55f16" />
        </linearGradient>
        <linearGradient id="hp-honey" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffd98c" />
          <stop offset="1" stopColor="#ffb454" />
        </linearGradient>
      </defs>
      {/* honey dipper, emerging from behind the lid */}
      <g stroke="#b07a33" strokeLinecap="round">
        <path d="M46 16 L52.5 8.9" strokeWidth="3.5" />
        <path d="M51.1 6.2 L55.9 10.5 M53.1 4 L57.9 8.3 M55.6 2.2 L59.4 5.7" strokeWidth="2.6" />
      </g>
      {/* jar body */}
      <path
        d="M17 20 C11 25 8 31 8 38 C8 51 18 58 32 58 C46 58 56 51 56 38 C56 31 53 25 47 20 Z"
        fill="url(#hp-pot)"
      />
      {/* rim band */}
      <rect x="13" y="12" width="38" height="10" rx="5" fill="url(#hp-honey)" />
      {/* honey drips */}
      <path d="M18 21 v7 a3.2 3.2 0 0 0 6.4 0 v-7 Z" fill="url(#hp-honey)" />
      <path d="M29 21 v12 a3.2 3.2 0 0 0 6.4 0 v-12 Z" fill="url(#hp-honey)" />
      <path d="M41 21 v5 a3 3 0 0 0 6 0 v-5 Z" fill="url(#hp-honey)" />
      {/* honeycomb cell */}
      <path
        d="M32 36 l7 4 v8 l-7 4 -7 -4 v-8 Z"
        fill="none"
        stroke="#7a480f"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
